import { module } from 'modujs';

export default class Hover extends module {
  constructor(m) {
    super(m);

    this.$button = this.el;
    this.$spans = this.$button.querySelectorAll('.c-button_span');

    this.hoverTimeout = null;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$button.addEventListener('mouseenter', this.onMouseEnter);
    this.$button.addEventListener('mouseleave', this.onMouseLeave);
  }

  unbindEvents() {
    this.$button.removeEventListener('mouseenter', this.onMouseEnter);
    this.$button.removeEventListener('mouseleave', this.onMouseLeave);

    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  onMouseEnter() {
    this.$button.classList.remove('is-out');
    this.$button.classList.add('is-hovered');
  }

  onMouseLeave() {
    this.$button.classList.remove('is-hovered');
    this.$button.classList.add('is-out');

    // Сброс через 400 мс (как длительность transition)
    this.hoverTimeout = setTimeout(() => {
      this.$button.classList.remove('is-out');
    }, 400);
  }

  destroy() {
    super.destroy();
    this.unbindEvents();
  }
}